import * as React from 'react';

import type FieldReportTypePreviewInModalVM from 'ab-viewModels/fieldReport/fieldReportTypeSidePanel.viewModel';

import type { getSegmentCount } from 'af-utils/fieldReport.util';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import FieldReportBlock from './FieldReportBlock';
import styles from './styles.module.scss';

type Props = {
	closeModal: () => void;
	onImageClick: (imageSrc: string) => void;
	showModal: boolean;
	currentFieldReportType: FieldReportTypePreviewInModalVM;
	fieldReportTypeTitle: string;
	segmentCountMap: ReturnType<typeof getSegmentCount>;
	instanceCount: number;
	onExportAsPDFClick: (fieldReportTypeIds: number[], isForCustomer: boolean, reportName: string) => () => Promise<void>;
};

const FieldReportTypePreviewModal: React.FC<Props> = (props) => {
	const {
		closeModal,
		showModal,
		currentFieldReportType,
		fieldReportTypeTitle,
		instanceCount,
		segmentCountMap,
		onExportAsPDFClick,
		onImageClick,
	} = props;

	const fieldReportBlockMapper = React.useCallback((_fieldReportBlock) => {
		const segmentCount = _fieldReportBlock.instanceIndex !== null ? segmentCountMap[_fieldReportBlock.instanceIndex] : 0;

		return (
			<FieldReportBlock
				fieldReportBlock={_fieldReportBlock}
				instanceCount={instanceCount}
				key={_fieldReportBlock.id}
				onImageClick={onImageClick}
				segmentCount={segmentCount}
				timezone={currentFieldReportType.timezone}
			/>
		);
	}, [currentFieldReportType.timezone, instanceCount, onImageClick, segmentCountMap]);

	const onExportClick = React.useCallback(() => {
		onExportAsPDFClick([currentFieldReportType.id], false, fieldReportTypeTitle)();
		closeModal();
	}, [closeModal, currentFieldReportType.id, fieldReportTypeTitle, onExportAsPDFClick]);

	return (
		<>
			<CustomModal
				closeModal={closeModal}
				showModal={showModal}
				size="xxl"
			>
				<CustomModal.Header
					closeModal={closeModal}
					title={`${fieldReportTypeTitle} (Read-only)`}
				/>
				<CustomModal.Body className={styles['side-panel-modal']}>
					{currentFieldReportType.fieldReportBlocks.map(fieldReportBlockMapper)}
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Close"
						onClick={closeModal}
						style="secondary"
					/>
					{!currentFieldReportType.isWorkOrderCanceled && (
						<Button
							label="Export as PDF"
							onClick={onExportClick}
							style="primary"
						/>
					)}
				</CustomModal.Footer>
			</CustomModal>

		</>
	);
};

export default React.memo(FieldReportTypePreviewModal);
